import { Plugins } from '@leverege/plugin';
import { Tree } from '@leverege/ui-elements';
const factory = Plugins.createFactory('ModelTreeEditor.NodeDelegate', {
  strategy: Plugins.LOOKUP,
  defaultObject: Tree.DefaultNodeDelegate
});
export default factory;